export type AccountMemberRole = "admin" | "user";

export type AccountRoleContext = {
  uid: string;
  auid?: string;
  isAccountAdmin?: boolean;
  isAccountOwner?: boolean;
};

/** True when the user can manage workspace org settings (owner or promoted admin). */
export function canManageAccount(ctx: AccountRoleContext): boolean {
  if (ctx.isAccountAdmin === true) return true;
  if (ctx.isAccountOwner === true) return true;
  // Server explicitly resolved member — do not fall back to stale `auid` on user docs.
  if (ctx.isAccountAdmin === false || ctx.isAccountOwner === false) return false;
  if (ctx.auid && ctx.uid === ctx.auid) return true;
  return false;
}

/** True when the user is the workspace owner (`accounts/{aid}.adminId`). */
export function isWorkspaceOwner(ctx: AccountRoleContext): boolean {
  if (ctx.isAccountOwner === true) return true;
  if (ctx.isAccountOwner === false) return false;
  if (ctx.auid && ctx.uid === ctx.auid) return true;
  return false;
}
